export const ERRORS: Record<number, string> = {
  400: "errors.invalid", // Bad request. Client has sent something weird
  401: "errors.unverified", // Unauthenticated request. Client didn't send an auth token
  403: "errors.forbidden", // Forbidden. Client is trying to access something they shouldn't
  404: "errors.notFound", // Resource not found / doesn't exist
  418: "errors.teapot", // Use this code for a silent failure
  429: "errors.tooManyRequests", // Client is making too many requests, too quickly
  500: "errors.alert", // Something's gone wrong on the backend
  502: "errors.serviceUnavailable", // A service behind the API failed
  503: "errors.serviceUnavailable", // A service behind the API is unavailable
  504: "errors.timeout", // The request ran out of time
};

export const MAX_REQUESTS_COUNT = 15;
export const INTERVAL_MS = 10;
export const TIMEOUT = 30000;
export const TIMEOUT_INFINITE = Infinity;

/** Above the API's 90s Silver Service cap, so a slow first run isn't aborted while the server completes it. */
export const TIMEOUT_LONG_RUNNING = 120000;

/** The API's generic message for errors it wraps; the real reason is then in the response `data`. */
export const API_UNHANDLED_ERROR_MESSAGE = "Unknown and unhandled error";
